module.exports = {
  "persistKeys": [
    "persistHideNav"
  ],
  "persistFilters": [],
  "useRavenMiddleware": true
};